import { Component, inject } from '@angular/core';
import { TranslatePipe } from '../../i18n/translate.pipe';
import { AuthService } from '../auth.service';

@Component({
  selector: 'cmi-login',
  imports: [TranslatePipe],
  templateUrl: './login.html'
})
export class Login {
  private readonly _authService = inject(AuthService);

  public onLoginClick(): void {
    this._authService.openDialog();
  }
}
